import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Flex, LabelMedium, LabelMediumBold } from '../../../../../../../primitives/index.js';
const IconContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1agkkie0"
} : {
  target: "e1agkkie0",
  label: "IconContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "oaldae",
  styles: "width:18px;height:18px;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:1px"
} : {
  name: "oaldae",
  styles: "width:18px;height:18px;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:1px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRpc3RhbmNlSXRlbS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHaUMiLCJmaWxlIjoiRGlzdGFuY2VJdGVtLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3gsIGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IEZsZXgsIExhYmVsTWVkaXVtLCBMYWJlbE1lZGl1bUJvbGQgfSBmcm9tICcuLi8uLi8uLi8uLi8uLi8uLi8uLi9wcmltaXRpdmVzL2luZGV4LmpzJztcbmNvbnN0IEljb25Db250YWluZXIgPSBzdHlsZWQuZGl2IGBcbiAgd2lkdGg6IDE4cHg7XG4gIGhlaWdodDogMThweDtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGZsZXgtc2hyaW5rOiAwO1xuICBtYXJnaW4tdG9wOiAxcHg7XG5gO1xuZXhwb3J0IGNvbnN0IERpc3RhbmNlSXRlbSA9ICh7IGljb24sIGRpc3RhbmNlLCBsYWJlbCwgfSkgPT4ge1xuICAgIHJldHVybiAoX2pzeHMoRmxleCwgeyBkaXJlY3Rpb246IFwicm93XCIsIHNwYWNpbmc6IFwiOHB4XCIsIGFsaWduSXRlbXM6IFwiZmxleC1zdGFydFwiLCBjaGlsZHJlbjogW19qc3goSWNvbkNvbnRhaW5lciwgeyBjaGlsZHJlbjogaWNvbiB9KSwgX2pzeHMoXCJkaXZcIiwgeyBjaGlsZHJlbjogW19qc3goTGFiZWxNZWRpdW1Cb2xkLCB7IGFzOiBcInNwYW5cIiwgY2hpbGRyZW46IGRpc3RhbmNlIH0pLCBfanN4cyhMYWJlbE1lZGl1bSwgeyBhczogXCJzcGFuXCIsIGNoaWxkcmVuOiBbXCIgXCIsIGxhYmVsXSB9KV0gfSldIH0pKTtcbn07XG4vLyMgc291cmNlTWFwcGluZ1VSTD1EaXN0YW5jZUl0ZW0uanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export const DistanceItem = ({
  icon,
  distance,
  label
}) => {
  return _jsxs(Flex, {
    direction: "row",
    spacing: "8px",
    alignItems: "flex-start",
    children: [_jsx(IconContainer, {
      children: icon
    }), _jsxs("div", {
      children: [_jsx(LabelMediumBold, {
        as: "span",
        children: distance
      }), _jsxs(LabelMedium, {
        as: "span",
        children: [" ", label]
      })]
    })]
  });
};